// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__IFQ5p","consentsList":"PatientConsents_consentsList__2NmYU","consentsListEmpty":"PatientConsents_consentsListEmpty__1uyJ8"};